import script from "./ViewConversation.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewConversation.vue?vue&type=script&setup=true&lang=js"

import "./ViewConversation.vue?vue&type=style&index=0&id=67a7abc4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a7abc4"]])

export default __exports__